import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CurrenciesList from "./List";
import CurrencyForm from "./Form";
import Currency from "./View";
import NotFound from "../NotFound";

import { PageHeader } from "../Shared";

import { currencyActions } from "./actions/currencies.actions";

export class ManageCurrencies extends Component {
  componentDidMount() {
    this.getCurrencies();
  }

  getCurrencies = () => {
    this.props.getCurrencies();
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;

    return (
      <div className="Currencies">
        <Row>
          <Col>
            <PageHeader pageId="currencies" pageTitle="Manage Currencies" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <CurrenciesList
                  match={match}
                  data={response}
                  loadData={this.getCurrencies}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route
              path={`${match.url}/list`}
              render={() => (
                <CurrenciesList
                  match={match}
                  data={response}
                  loadData={this.getCurrencies}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route path={`${match.url}/add`} component={CurrencyForm} />
            <Route path={`${match.url}/view/:id`} component={Currency} />
            <Route path={`${match.url}/edit/:id`} component={CurrencyForm} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.currencies;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCurrencies: bindActionCreators(
      currencyActions.getAllCurrencies,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCurrencies);
